import { Card, Empty, Tag } from "antd";

export default function RecentOptimizations({ data = [] }) {
  return (
    <Card title="Recent Optimizations" className="rounded-3xl shadow-sm">
      {data.length === 0 ? (
        <Empty description="No optimizations yet" />
      ) : (
        <div className="space-y-4">
          {data.map((item) => (
            <div key={item._id} className="flex items-center gap-4 border-b pb-4 last:border-0">
              <img
                src={item.imgurl}
                alt=""
                className="w-14 h-14 rounded-xl object-cover bg-slate-100"
              />

              <div className="flex-1">
                <h4 className="m-0 font-bold">{item.category}</h4>
                <p className="m-0 text-slate-500 text-sm">
                  Shipping ₹{item.originalshipping} → ₹{item.optimizedshipping}
                </p>
              </div>

              <div className="text-right">
                <p className="m-0 text-green-600 font-bold">Saved ₹{item.savings}</p>
                <Tag color="green">Completed</Tag>
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}